import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MultiSelect } from 'primeng/multiselect';

@Component({
  selector: 'form-multiselect',
  template: `
    <div class="form-group">
    <label class="col-form-label font-weight-bold">{{label}}</label>
    <ng-template [ngIf]="loading">
    <br>
    <p-progressSpinner [style]="{width: '20px', height: '20px'}"></p-progressSpinner>
    </ng-template>
      <p-multiSelect 
        #multiSelectRef
        [hidden]="loading"
        styleClass="w-100"
        [options]="items" 
        [formControl]="control" 
        [defaultLabel]="placeholder"
        [resetFilterOnHide]="true"
        (onChange)="selectChanged.emit($event)">
      </p-multiSelect>
      <div *ngIf="control.invalid && control.dirty" class="text-danger-form">{{errorMsg ? errorMsg : 'campoObbligatorio' | translate}}</div>
    </div>
  `,
})
export class FormMultiselectComponent {

  @ViewChild('multiSelectRef') multiSelectRef: MultiSelect;

  // input onChange:
  @Input() control: AbstractControl;
  @Input() items: any[];
  @Input() loading: boolean;
  @Input() errorMsg: string;

  // input "fissi":
  @Input() label: string;
  @Input() placeholder: string;
  @Input() labelFieldName = 'label';
  @Input() valueFieldName = 'value';
  @Input() maxSelectedLabels = 3;

  @Output() selectChanged: EventEmitter<any> = new EventEmitter();

  closeDropdown() {
    if (this.multiSelectRef != null) {
      this.multiSelectRef.hide();
    }
  }

}

// <p-multiSelect
//  [selectedItemsLabel]="'{0} ' + ('elementiSelezionati'|translate)">
// </p-multiSelect>